var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import sprintf from './sprintf';
export default function printf(format) {
    var a = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        a[_i - 1] = arguments[_i];
    }
    if (process) {
        return process.stdout.write(sprintf.apply(void 0, __spreadArray([format], a, false)));
    }
    return console.log(sprintf.apply(void 0, __spreadArray([format], a, false)));
}
